import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { useGetMediaQuery } from '#hook/use-get-media-query';

import { COMMON } from '#route/config';

const ROUTES = Sentry.wrapCreateBrowserRouter(createBrowserRouter)(COMMON, {
    basename: '/'
});

export const Routes = () => {
    useGetMediaQuery();

    return <RouterProvider router={ROUTES} />;
};
